import BaseStore from './BaseStore';
import rp from 'request-promise';
import config from '../config';
import { getToken } from '../components/Token';
import { getTenantHeaders } from '../components/TenantHeaders';

export class UploadStore extends BaseStore {
  async deleteFile(path) {
    try {
      const res = await rp
        .put(`${config.api.url}/${config.api.version}/upload/remove`, {
          body: { path },
          json: true,
          authorization: true,
          resolveWithFullResponse: true,
          headers: {
            ...getTenantHeaders(),
          },
        })
        .auth(null, null, true, getToken('id_token'));
      if (res) {
        return res;
      } else {
        throw new Error(res.body.message || 'Error when delete file.');
      }
    } catch (err) {
      console.log('deleteFile ===> ', err);
      // if (err.statusCode === 401) {
      //   setTimeout(() => {
      //     removeToken('id_token')
      //     window.location.href = '/login'
      //   }, 1000)
      // }
      // return false;
      throw err;
    }
  }
}

export default new UploadStore();
